import {useState} from 'react'
import {Box} from '@mui/material'
import PropTypes from 'prop-types'
import {StyledIconButton, StyledTypography, StyledTooltip} from '../TimeSeriesDashboardStyle'
import {InfoOutlined} from '@mui/icons-material'
const ChartTitle = ({title, showInfo}) => {
  const [isToolTipOpen, setIsToolTipOpen] = useState(false)
  const handleClickAway = () => {
    setIsToolTipOpen(false)
  }

  const tooltipText =
    'Displayed risk scores predict the likelihood of the selected population having the chosen Health condition, accounting for their socioeconomic, behavioral, and lifestyle characteristics.'
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginLeft: '7px',
        width: '100%'
      }}
    >
      <Box display={'flex'} justifyContent={'flex-start'}>
        <StyledTypography tabIndex={0} aria-label={`${title}-chart`}>
          {title}
        </StyledTypography>
        {showInfo && (
          <StyledTooltip
            enterTouchDelay={0}
            title={tooltipText}
            open={isToolTipOpen}
            onClickAway={handleClickAway}
            disableHoverListener={true}
            aria-describedby={`${title}-tooltip`}
            id={`${title}-tooltip`}
          >
            <StyledIconButton
              onClick={() => setIsToolTipOpen(!isToolTipOpen)}
              aria-label={isToolTipOpen ? tooltipText : 'Toggle risk chart tooltip'}
              aria-controls={`${title}-tooltip`}
              aria-expanded={isToolTipOpen}
            >
              <InfoOutlined />
            </StyledIconButton>
          </StyledTooltip>
        )}
      </Box>
    </Box>
  )
}

ChartTitle.propTypes = {
  title: PropTypes.string,
  showInfo: PropTypes.bool
}

export default ChartTitle
